.gf{border:1px solid #ddd;}